"use client"

import { useEffect, useState } from "react"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"
import { useTheme } from "@/features/theme/theme.provider"

function useToasterTheme(): ToasterProps["theme"] {
  const { resolvedTheme } = useTheme()
  const [phoneLight, setPhoneLight] = useState(false)
  useEffect(() => {
    const read = () =>
      setPhoneLight(document.documentElement.hasAttribute("data-do-phone-light"))
    read()
    const mo = new MutationObserver(read)
    mo.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-do-phone-light"],
    })
    return () => mo.disconnect()
  }, [])
  return phoneLight ? "light" : (resolvedTheme ?? "light")
}

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = useToasterTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: (
          <CircleCheckIcon className="size-4" />
        ),
        info: (
          <InfoIcon className="size-4" />
        ),
        warning: (
          <TriangleAlertIcon className="size-4" />
        ),
        error: (
          <OctagonXIcon className="size-4" />
        ),
        loading: (
          <Loader2Icon className="size-4 animate-spin" />
        ),
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
